module.exports = __webpack_public_path__ + "static/media/badge.db50831f.png";